import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";

function Gallery() {
  const [albums, setAlbums] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [albumsRes, settingsRes] = await Promise.all([
        axiosInstance.get("/api/gallery/albums"),
        axiosInstance.get("/api/settings"),
      ]);
      setAlbums(albumsRes.data);
      setSettings(settingsRes.data);
    } catch (err) {
      console.error("Failed to load gallery", err);
    } finally {
      setLoading(false);
    }
  };

  const primaryColor = settings?.theme_primary_color || "#0d6efd";

  return (
    <div>
      <section
        className="py-4 text-white"
        style={{ backgroundColor: primaryColor }}
      >
        <div className="container">
          <h1 className="fw-bold mb-0">Photo Gallery</h1>
          <p className="mb-0 opacity-75">
            Moments from {settings?.school_name}
          </p>
        </div>
      </section>

      <div className="container py-5">
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : albums.length === 0 ? (
          <p className="text-muted text-center py-5">
            No albums published yet.
          </p>
        ) : (
          <div className="row g-4">
            {albums.map((album) => (
              <div className="col-12 col-sm-6 col-lg-4" key={album.id}>
                <div
                  className="card border-0 shadow-sm h-100"
                  role="button"
                  onClick={() => navigate(`/gallery/${album.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    style={{
                      height: "200px",
                      overflow: "hidden",
                      background: "#f0f0f0",
                    }}
                  >
                    {album.cover_image_path ? (
                      <img
                        src={`${process.env.REACT_APP_API_URL}/${album.cover_image_path}`}
                        alt={album.title}
                        className="w-100 h-100"
                        style={{
                          objectFit: "cover",
                          transition: "transform 0.3s",
                        }}
                      />
                    ) : (
                      <div className="d-flex align-items-center justify-content-center h-100">
                        <i
                          className="bi bi-images text-muted"
                          style={{ fontSize: "2.5rem" }}
                        ></i>
                      </div>
                    )}
                  </div>
                  <div className="card-body">
                    <h5 className="fw-bold mb-1">{album.title}</h5>
                    {album.description && (
                      <p className="text-muted small mb-2">
                        {album.description}
                      </p>
                    )}
                    {album.event_date && (
                      <p className="text-muted small mb-0">
                        <i className="bi bi-calendar3 me-1"></i>
                        {new Date(album.event_date).toLocaleDateString(
                          "en-IN",
                          {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          },
                        )}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Gallery;
